import React from "react";
import { View, Text, StyleSheet, ScrollView, Image } from "react-native";
import { useTranslation } from "react-i18next";
import SuccessIcon from "../../../../../../../assets/images/success-icon-component.png";

type Props = {};

export default function FraudPreventionStep(_: Props) {
  const { t } = useTranslation(); // if you have i18n keys, replace static text with t("...")

  return (
    <ScrollView
      style={styles.container}
      contentContainerStyle={styles.content}
      showsVerticalScrollIndicator={false}
    >
      {/* Check icon */}
      <View style={styles.iconCircle}>
        <Image source={SuccessIcon} style={styles.successIconStyle} />
      </View>

      {/* Heading */}
      <Text style={styles.title}>Fraud prevention</Text>
      <Text style={styles.subtitle}>
        Fraud warning about your money transfer
      </Text>

      {/* Body */}
      <Text style={styles.paragraph}>
        Keep your money safe. If any of the below apply,{" "}
        <Text style={styles.bold}>DO NOT SEND</Text> the money transfer. It’s a
        scam and someone is trying to steal your money. If you send money, it
        can be paid out quickly, and you may not be able to get a refund.
      </Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. To donate to a charity or to pay an internet merchant during a
          crisis
        </Text>
        <Text style={styles.listItem}>
          2. To receive money (e.g., lottery winnings, prizes or job offers)
        </Text>
        <Text style={styles.listItem}>3. To pay the IRS or police</Text>
        <Text style={styles.listItem}>
          4. To buy a car, puppy or other high-value item, or for “escrow” for
          housing
        </Text>
      </View>

      <Text style={styles.paragraph}>
        If you feel like you are a victim of fraud please call{" "}
        <Text style={styles.bold}>1-800-926-9400</Text> for assistance or visit{" "}
        <Text style={styles.link}>www.moneygram.com</Text> and file a complaint.
      </Text>

      <Text style={[styles.paragraph, styles.bold]}>
        Are you sending money for something a telemarketer sold you?
      </Text>

      <Text style={styles.paragraph}>
        Sellers and telemarketers can’t take money transfer payments from people
        in the US for something they’re selling.
      </Text>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: "#fff" },
  successIconStyle: {
    width: 80,
    height: 80
  },
  content: {
    paddingHorizontal: 24,
    paddingTop: 32,
    paddingBottom: 40,
  },
  iconCircle: {
    alignSelf: "center",
    width: 72,
    height: 72,
    borderRadius: 36,
    backgroundColor: "#eee",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 24,
  },
  check: { fontSize: 36, color: "#555" },
  title: {
    fontSize: 22,
    fontWeight: "700",
    textAlign: "center",
    color: "#111827",
    marginTop: 16,
    marginBottom: 32,
  },
  subtitle: {
    fontSize: 14,
    textAlign: "center",
    color: "#6B7280",
    marginBottom: 24,
  },
  paragraph: {
    fontSize: 14,
    color: "#444",
    marginBottom: 16,
    lineHeight: 20,
  },
  bold: { fontWeight: "600", color: "#111827" },
  link: { color: "#1D4ED8", textDecorationLine: "underline" },
  list: { marginBottom: 16 },
  listItem: { fontSize: 14, color: "#444", marginBottom: 8, lineHeight: 20 },
});